// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/type/v1/payment.proto (package gportal.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum gportal.type.v1.PaymentProvider
 */
export enum PaymentProvider {
  /**
   * @generated from enum value: PAYMENT_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_CHARGEBEE = 1;
   */
  CHARGEBEE = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(PaymentProvider)
proto3.util.setEnumType(PaymentProvider, "gportal.type.v1.PaymentProvider", [
  { no: 0, name: "PAYMENT_PROVIDER_UNSPECIFIED" },
  { no: 1, name: "PAYMENT_PROVIDER_CHARGEBEE" },
]);

